import React from 'react';
import { useLocation } from 'react-router-dom';
import BananasGPTApp from '../components/BananasGPT/BananasGPTApp';

const BananasGPT = () => {
    const { pathname } = useLocation();
    const provider = pathname.includes('/nanogpt') ? 'nanogpt' : 'openrouter';
    return (
        <div className="h-full w-full">
            <BananasGPTApp key={provider} provider={provider} />
        </div>
    );
};

export default BananasGPT;
